export default "__VITE_ASSET__CiDJvWmK__"